/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Summary_DInputs */

const en_rd_summary_d = /** @type {(inputs: Rd_Summary_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risky. Expect wrong assumptions and work you cannot verify.`)
};

const id_rd_summary_d = /** @type {(inputs: Rd_Summary_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berisiko. Siap-siap asumsi keliru dan hasil yang tak bisa kamu verifikasi.`)
};

/**
* | output |
* | --- |
* | "Risky. Expect wrong assumptions and work you cannot verify." |
*
* @param {Rd_Summary_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_summary_d = /** @type {((inputs?: Rd_Summary_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Summary_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_summary_d(inputs)
	return en_rd_summary_d(inputs)
});